import { getFormFieldsDiffList } from "../../../utils/editorUtils";
import DeleteBaseCommand from "./deleteBaseCommand";

class DeletePDFDocCommand extends DeleteBaseCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  execute() {
    const { section, mode, sectionID } = this.componentData;
    this.updatedSection = section;
    if (section) {
      this.updatedSection.fieldDiffList = getFormFieldsDiffList(section, null);
    }

    this.componentData.deleteDocumentComponentAction(
      sectionID,
      this.updatedSection,
    );
    const data = this.componentData.signerData.find(
      item => item.component_id === sectionID,
    );
    const deleteSigner = [
      {
        component_id: data.component_id,
        ids: [data.signers[0].id],
      },
    ];
    // Only 1 component for PDF - signature component
    this.componentData.deleteDocSignerSection(
      mode,
      deleteSigner,
      this.componentData.docID,
    );
  }

  undo() {
    super.undo();
    // only 1 component hence call here
  }
}

export default DeletePDFDocCommand;
